export class ServiceFee {
    FullDay?: number;
    HalfDay?: number;
}